var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlanLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H35.9337V26.7589L35.9343 26.7586L35.9343 37.08L35.9343 47.4014L17.9683 36.6982L0.00141239 47.3774L0.00141262 37.0636L0.00141338 36.6982H0V0Z",
    fill: "#3A74F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanLabel);
export default __webpack_public_path__ + "static/media/icon-plan-label.8b4233e4d2530055788d8c38b41637e2.svg";
export { ForwardRef as ReactComponent };